import { useNavigate } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function News() {
  const titleAnimation = useScrollAnimation();
  const news1Animation = useScrollAnimation();
  const navigate = useNavigate();

  const newsItems = [
    {
      id: 1,
      date: '2026.01.01',
      category: 'お知らせ',
      title: 'ホームページ開設のお知らせ',
      animation: news1Animation
    }
  ];

  return (
    <section id="news" className="py-12 sm:py-16 bg-cyan-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div 
          ref={titleAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`text-center mb-12 sm:mb-16 scroll-animate ${titleAnimation.isVisible ? 'is-visible' : ''}`}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">お知らせ</h2>
        </div>
        <div className="max-w-4xl mx-auto space-y-4 sm:space-y-6">
          {newsItems.map((item, index) => (
            <div
              key={item.id}
              ref={item.animation.ref as React.RefObject<HTMLDivElement>}
              className={`bg-white p-4 sm:p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer scroll-animate scroll-animate-delay-${index + 1} ${item.animation.isVisible ? 'is-visible' : ''}`}
              onClick={() => navigate(`/news/${item.id}`)}
            >
              <div className="flex flex-col md:flex-row md:items-center gap-3 sm:gap-4">
                <div className="flex items-center gap-3 sm:gap-4 flex-wrap">
                  <span className="text-gray-600 font-medium whitespace-nowrap text-sm sm:text-base">{item.date}</span>
                  <span className="bg-teal-100 text-teal-700 px-3 sm:px-4 py-1 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <h3 className="text-gray-900 font-semibold text-base sm:text-lg flex-1">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
